// extracted by mini-css-extract-plugin
var _1 = "uNcbwLRPpBD3jgy3T0Ca";
var _2 = "GX64tK27U_klBEx1D_mY";
var _3 = "CJoGiBmtYPtVdtHdGgbz";
var _4 = "OWIrI61YkiBtithyQULA";
var _5 = "GEQrTec57DD2DiB4PWKY";
export { _1 as "menuItem", _2 as "menuItemActive", _3 as "menuItemClickable", _4 as "menuItemDisabled", _5 as "menuItemLight" }
export default { "menuItem": _1, "menuItemActive": _2, "menuItemClickable": _3, "menuItemDisabled": _4, "menuItemLight": _5 }
